import React from 'react'
import { Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const ZipExportReadyActions = ({ url }) => {
    const handleDownloadClick = event => {
        event.preventDefault()
        event.stopPropagation()
        window.open(url, '_blank')
    }

    return (
        <Button type='primary' size='small' icon={<DownloadOutlined />} onClick={handleDownloadClick}>
            Download
        </Button>
    )
}

export default ZipExportReadyActions

